import React, {useState, useEffect} from "react";
import moment from "moment";
import { useParams } from "react-router-dom";
/*import 'bootstrap/dist/js/bootstrap.bundle.min.js';
import { Link } from "react-router-dom";
import "./../../Public/css/bootstrap.min.css";
import "./../../Public/css/tabler-icons.css";
import "./../../Public/css/fontawesome.min.css";
import "./../../Public/css/all.min.css";
import "./../../Public/css/style.css";*/

import {CampaignReportAPI, CampaignLeadsAPI} from "./../../../API/Admin/CampaignAPI";
import Sidebar from "./../Common/Sidebar";
import Header from "./../Common/Header";
import Loader from "./../../Loader";
import Paginate from "../../../utils/Pagination";


const CampaignReport = () =>{

    const {campaignid} = useParams();

    const [totalleadcount, setTotalLeadCount] = useState(0);
    const [assignedleadcount, setAssignedLeadCount] = useState(0);
    const [pendingleadcount, setPendingLeadCount] = useState(0);
    const [noanswerleadcount, setNoAnswerLeadCount] = useState(0);
    const [todayleadcount, setTodayLeadCount] = useState(0);
    const [calledleadcount, setCalledLeadCount] = useState(0);
    const [convertedleadcount, setConvertedLeadCount] = useState(0);
    const [notinterestleadcount, setNotInterestLeadCount] = useState(0);
    const [callbackleadcount, setCallBackLeadCount] = useState(0);
    const [nextyearleadcount, setNextYearLeadCount] = useState(0);
    const [leads, setLeads] = useState([]);
    const [loading, setLoading] = useState(true);
    const [currentPage, setCurrentPage] = useState(1);
    const [pagecount, setPageCount] = useState(0);
    const [leadloading, setLeadLoading] = useState(true);

    const perpagedata = 15;

    useEffect(() =>{
        console.log('Admin dahboard');

        CampaignReportAPI(setTotalLeadCount, setAssignedLeadCount, setPendingLeadCount, setNoAnswerLeadCount, setTodayLeadCount, setCalledLeadCount, setConvertedLeadCount, setNotInterestLeadCount, setCallBackLeadCount, setNextYearLeadCount, setLoading, campaignid);

        CampaignLeadsAPI(setLeads, campaignid, currentPage, perpagedata, setPageCount, setLeadLoading);
        
    }, []);

    const handlePageClick = (data) =>{
        setCurrentPage(data.selected + 1);
        
        CampaignLeadsAPI(setLeads, campaignid, currentPage, perpagedata, setPageCount, setLeadLoading);
    }


    return(
    <div className="main-wrapper">

        <Loader />

        <Header />

        <Sidebar />

        <div className="page-wrapper">
            <div className="content">
                <div className="row">
                    <div className="col-md-12">
                        <div className="page-header">
                            <div className="row align-items-center ">
                                <div className="col-md-4">
                                    <h3 className="page-title">Campaign Report</h3>
                                </div>
                                <div className="col-md-8 float-end ms-auto">
                                    
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="row">
                    <div className="col-md-3">
                        <div className="card card-border-bottom">
                            <div className="card-body p-3 d-flex align-items-center">                            	
                                <div>
                                    <div className="fs-4 fw-semibold widget-text">{totalleadcount}</div>
                                    <div className="text-body-secondary fw-semibold widget-heading">Total Leads</div>
                                </div>
                            </div>
                            
                        </div>
                    </div>

                    <div className="col-md-3">
                        <div className="card card-border-bottom">
                            <div className="card-body p-3 d-flex align-items-center">                            	
                                <div>
                                    <div className="fs-4 fw-semibold widget-text">{pendingleadcount}</div>
                                    <div className="text-body-secondary fw-semibold widget-heading">Pending Leads</div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="col-md-3">
                        <div className="card card-border-bottom">
                            <div className="card-body p-3 d-flex align-items-center">                            	
                                <div>
                                    <div className="fs-4 fw-semibold widget-text">{noanswerleadcount}</div>
                                    <div className="text-body-secondary fw-semibold widget-heading">No-Answer Leads</div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="col-md-3">
                        <div className="card card-border-bottom">
                            <div className="card-body p-3 d-flex align-items-center">                            	
                                <div>
                                    <div className="fs-4 fw-semibold widget-text">{todayleadcount}</div>
                                    <div className="text-body-secondary fw-semibold widget-heading">Today Leads</div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="col-md-3">
                        <div className="card card-border-bottom">
                            <div className="card-body p-3 d-flex align-items-center">                            	
                                <div>
                                    <div className="fs-4 fw-semibold widget-text">{calledleadcount}</div>
                                    <div className="text-body-secondary fw-semibold widget-heading">Called Leads</div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="col-md-3">
                        <div className="card card-border-bottom">
                            <div className="card-body p-3 d-flex align-items-center">                            	
                                <div>
                                    <div className="fs-4 fw-semibold widget-text">{convertedleadcount}</div>
                                    <div className="text-body-secondary fw-semibold widget-heading">Converted Leads</div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="col-md-3">
                        <div className="card card-border-bottom">
                            <div className="card-body p-3 d-flex align-items-center">                            	
                                <div>
                                    <div className="fs-4 fw-semibold widget-text">{notinterestleadcount}</div>
                                    <div className="text-body-secondary fw-semibold widget-heading">Not-Interested Leads</div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="col-md-3">
                        <div className="card card-border-bottom">
                            <div className="card-body p-3 d-flex align-items-center">                            	
                                <div>
                                    <div className="fs-4 fw-semibold widget-text">{nextyearleadcount}</div>
                                    <div className="text-body-secondary fw-semibold widget-heading">Next Year Leads</div>
                                </div>
                            </div>
                        </div>
                    </div>					
                </div>

                <div className="row">
                    <div className="col-md-12">
                        <div className="card w-100">
                            <div className="card-header border-0 pb-0">
                                <h4><i className="ti ti-grip-vertical me-1"></i>Campaign Leads</h4>
                            </div>
                            <div className="card-body">
                                <div className="table-responsive">
                                    <table className="table table-nowrap mb-0" id="">
                                        <thead className="thead-light">
                                            <tr>
                                                <th>Name</th>
                                                <th>Email</th>
                                                <th>Contact</th>
                                                <th>Location</th>
                                                <th>Lead Status</th>
                                                <th>Caller Name</th>
                                                <th>Created Date</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                    
                                        {leadloading ?
                                            <tr>
                                                <td colSpan="7">
                                                    <Loader />
                                                </td>
                                            </tr>
                                        :
                                            (leads && leads.length > 0  ? 
                                                ( leads.map(lead => 
                                                    (
                                            
                                                        <tr key={lead.id}>
                                                            <td>{lead.name}</td>
                                                            <td>{lead.email}</td>
                                                            <td>{lead.contact}</td>
                                                            <td>{lead.location}</td>
                                                            <td>
                                                                {lead.leadstatus ?
                                                                    <span class="badge badge-tag badge-purple-light">{lead.leadstatus}</span>
                                                                :
                                                                    <span>-</span>
                                                                }
                                                            </td>
                                                            <td>{lead.callername}</td>
                                                            <td>
                                                                {moment(lead.created_at).format('DD-MMM-YYYY h:mm:ss') }
                                                            </td>
                                                            
                                                        </tr>
                                                    )
                                                ))
                                            
                                            :
                                        
                                                <tr>
                                                    <td colSpan="7">
                                                        <p>No record found...</p>
                                                    </td>
                                                </tr>
                                            )
                                        }
                                    
                                        </tbody>
                                    </table>
                                    
                                </div>
                                <div className="pagination-section mt-3">

                                    <nav>
                                        <Paginate initialPage={perpagedata} pageCount={pagecount} onPageChange={handlePageClick} />
                                    </nav>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    )
}

export default CampaignReport;